import { put, takeLatest } from 'redux-saga/effects'
import * as actions from '../store/procedure.actions'
import { AirwayConstants } from '../../../features/procedures/airway/store/airway.constants'
import { CardiacConstants } from '../../../features/procedures/cardiac/store/cardiac.constants'
import { InitiateIvConstants } from '../../../features/procedures/initiateIv/store/initiateIv.constants'
import { IntubationConstants } from '../../../features/intubation/store/intubation.constants'
import { MedicalConsultConstants } from '../../../features/procedures/medicalConsult/store/medicalConsult.constants'
import { AddMedicationAdministeredConstants } from '../../../features/addMedicationAdministered/store/addMedicationAdministered.constants'
import { DrainConstants } from '../../../features/procedures/drain/store/drain.constants'
import { CriticalCareConstants } from '../../../features/procedures/criticalCare/store/criticalCare.constants'

export function* setIsFirstVisit() {
  yield put(actions.setIsFirstVisit(true))
}

export function* setIsFirstVisitSaga() {
  yield takeLatest(
    [
      AirwayConstants.ON_SELECT_AIRWAY,
      CardiacConstants.ON_SELECT_CARDIAC,
      DrainConstants.ON_SELECT_DRAIN,
      InitiateIvConstants.ON_SELECT_INITIATE_IV,
      IntubationConstants.ON_SELECT_INTUBATION,
      MedicalConsultConstants.ON_SELECT_MEDICAL_CONSULT,
      AddMedicationAdministeredConstants.ON_SELECT_MEDICATION_ADMINISTERED,
      CriticalCareConstants.ON_SELECT_CRITICAL_CARE,
    ],
    setIsFirstVisit
  )
}
